(function () {
  const cookiesPopup = document.getElementById("cookies-popup");
  const acceptCookies = document.getElementById("accept-cookies");
  const declineCookies = document.getElementById("decline-cookies");

  var link = document.createElement("link");

  // Set the attributes for the link
  link.setAttribute(
    "href",
    "https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css"
  );
  link.setAttribute("rel", "stylesheet");

  // Append link element to HTML head
  document.head.appendChild(link);

  if (!localStorage.getItem("cookiesAccepted")) {
    cookiesPopup.style.display = "flex";
  }

  acceptCookies.addEventListener("click", () => {
    localStorage.setItem("cookiesAccepted", 1);
    cookiesPopup.style.display = "none";
  });

  declineCookies.addEventListener("click", () => {
    cookiesPopup.style.display = "none";
  });
})();